export const TREEMAP_LABEL_STOPWORDS = [
  'excellence',
  'President',
  'P.m',
  'Expected',
  'Million',
  'Speech',
  'value',
  'Theme',
  'Sound',
  'Activities',
  'Increase',
  'EPA Award',
  'EPA',
  'Report Published',
  'Report',
  'State',
  'Federal',
  'Review',
  'Tasks',
  'Group',
  'Goods',
  'Area',
  'Plan',
  'Set',
  'Targets',
  'going',
  'studies',
  'Board',
  'Lists',
  'EPA Announce',
  'Article',
  'Create New',
  'Placce',
  'Pay',
  'Prime Minister',
  'Annual Report',
  'Billion Yuan',
  'Business',
  'Cabinet Office',
  'Campaign',
  'Canada Canada',
  'City',
  'Committee',
  'Committee Expert',
  'Commons Chamber',
  'Daily Highlights',
  'Department of Industrial Works',
  'Deputy Minister',
  'Deputy Prime Minister',
  'Early',
  'Environmental Protection',
  'European Commission',
  'European Council',
  'European Union',
  'event',
  'Federal Council',
  'Foreign Minister',
  'Forum',
  'Government of Canada',
  'Human Rights',
  'Human Rights Council',
  'know',
  'Local Governments',
  'Member of Commission',
  'Million People',
  'Minister of Environment',
  'Minister of Foreign Affairs',
  'Minister of the Environment',
  'Ministry of Agriculture',
  'Ministry of Environment',
  'Ministry of Environment and Natural Resources',
  'Ministry of Health',
  'Ministry of Industry',
  'Ministry of Industry and Information Technology',
  'Ministry of Transport',
  'Party Central Committee',
  'Permanent Secretary',
  'Power',
  'President Xi Jinping',
  'Press Release',
  "Privacy Commissioner's Office",
  'Private Sector',
  'Program',
  'Province',
  'Risk',
  'Scheme',
  'Secretary',
  'Secretary of State',
  'staff',
  'State Secretary',
  'Students',
  'Study',
  'Sustainable Development',
  'Sustainable Development Goals',
  'U.S. Department of Labor Investigation',
  'United Nations',
  'university to reserch',
  'Vice President',
  'visit',
  'Westminster Hall',
  'World Economic Forum',
  'year',
  'case',
  'awareded',
  'award',
  'bill',
  'statament',
  'U.S.',
  'applications',
  'strategic',
  'finds',
  'second',
  'years ago',
  'Act Act',
  'team',
  'aligns',
  'service',
  'address',
  'concept',
  'meeting',
  'Annual Report',
  'Address',
  'Activities',
  'Article',
  'Application',
  'Board',
  'Association',
  'Business',
  'Book',
  'City',
  'Carbon Emissions',
  'Climate Change',
  'Cause',
  'Clean',
  'Committee',
  'Contract',
  'Cooperation',
  'Construction',
  'Conditions',
  'Damage',
  'Data Protection Officer',
  'Defense',
  'Development',
  'Discussion',
  'Effect',
  'Elements',
  'Equipment',
  'Event',
  'Experience',
  'Federal Council',
  'Finance',
  'Food Security',
  'Forum',
  'Function',
  'General Manager',
  'Government',
  'Help',
  'Human Rights',
  'Ideas',
  'Implementation',
  'Industry',
  'Information',
  'Knowledge',
  'Learning',
  'Management',
  'Meeting',
  'Member',
  'Million',
  'Minister',
  'National Council',
  'Organization',
  'Parliament',
  'Policy',
  'Power',
  'President',
  'Privacy',
  'Program',
  'Project',
  'Protection',
  'Province',
  'Research',
  'Resources',
  'Review',
  'Risk',
  'Sanitation',
  'Scheme',
  'School',
  'Secretary',
  'Security',
  'Social Affairs',
  'Solutions',
  'Speech',
  'Staff',
  'State',
  'Study',
  'Sustainable Development',
  'System',
  'Technology',
  'Theme',
  'Trade Union',
  'Training',
  'Transition',
  'University',
  'Visit',
  'Week',
  'Workers',
];
